module.exports = __webpack_public_path__ + "img/button-home5.8509c637.png";